'use strict';

(function () {
	angular.module('natiwi.form', ['natiwi.core.cdn']);
})();